<template>
  <PokerTableSkeleton
    class="tbl_study tblppstudy anim-fade-ins"
    :players="l_players"
    tstPrefix="study"
  >
    <template #center>
      <PokerPot :spot="spot">
        <PokerBoard :spot="{ board }" />
      </PokerPot>
    </template>
    <template
      v-for="player in l_players"
      #[player.position]
      :key="player.position"
    >
      <slot :name="`${player.position}_before`" />
      <PokerPlayer
        :hasTimetravel="true"
        :hasCards="false"
        :player="player"
      >
        <template #[player.position]>
          <slot :name="player.position" />
        </template>
      </PokerPlayer>
    </template>
  </PokerTableSkeleton>
</template>

<script>
import PokerTableSkeleton from '@/components/PokerTable/PokerTableSkeleton'
import { getPlayersDefault } from '@/store/gamestate/gamestate'
import PokerPlayer from '@/components/PokerTable/PokerPlayer'
import PokerBoard from '@/components/PokerTable/PokerBoard'
import PokerPot from '@/components/PokerTable/PokerPot'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'PokerTableStudy',
  components: {
    PokerPlayer,
    PokerBoard,
    PokerPot,
    PokerTableSkeleton,
  },
  props: {
    spot: Object,
    namespace: { String, required: true },
    hasEmptyFlopBoard: {
      default: false,
      type: Boolean,
    },
    gameformat: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    openBoardDialog() {
      // TR-TODO  openBoardDialog
      const tmpNamespace = 'tmp/primary'
      const cpParams = {
        from_namespace: this.namespace,
        to_namespace: tmpNamespace,
        queryGroup: 'board-filter',
      }
      this.$store.dispatch('poker_copy_module', cpParams)
      const tab = 'flop'
      let dialog = 'practice-filter-dialog'
      dialog = `${dialog}_tab-${tab}_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    l_players() {
      return this.spot?.players || getPlayersDefault({ gameformat: this.gameformat })
    },
    board() {
      return this.hasEmptyFlopBoard
        ? 'EeEeEe'
        : this.$store.getters[SNK('street_board_any', this.namespace)](this.spot?.street).join('')
    },
    devPlayers() {
      // return [...new Array(2).keys()]
      // return [...new Array(3).keys()]
      // return [...new Array(4).keys()]
      // return [...new Array(5).keys()]
      // return [...new Array(6).keys()]
      // return [...new Array(7).keys()]
      return (
        [...new Array(8).keys()]
          // return [...new Array(9).keys()]
          .map((i, idx) => ({
            stack: 99,
            // position: 'UTG',
            position: `UTG${idx}`,
            hand: 'AsAs',
            // hand: 'EeEe',

            chips_on_table: 99,
            current_stack: 99,
            next_chips_on_table: 99,
            next_current_stack: 99,
            // is_dealer: true,
            is_folded: false,
            next_is_folded: false,
            is_hero: false,
            is_active: false,
          }))
      )
    },
  },
}
</script>
<style lang="scss">
.tblppstudy {
  margin: 0;
  * {
    transition: none !important;
    animation: none !important;
    transform: none !important;
    transition-property: none !important;
    // box-shadow: 0px 0px 1px rgba(255, 0, 0, 0.747);
  }
}
</style>
